// react-native-spinkit has no web build but is rendered as a component
// (loading spinners). Shim to a valid null-rendering React component.
function Loader() {
  return null;
}
module.exports = Loader;
module.exports.default = Loader;
